import { useRef, useState } from 'react';
import { useGetPipeline, useLazyQueryPipelineIntegrationAttachment } from '@ion/api';

// Fetches the two per-pipeline inputs the chain needs once a pipeline is
// selected: the DEPLOYED pipeline from roost (pipeline-level transform +
// filter; a 404 means never deployed → stage 2 is a passthrough) and this
// integration's attachment row from Hasura (pipelineVars + consent, when
// the integration is attached to the selected pipeline).
export default function useSelectedPipelineData({ integrationId, clusterId }) {
  const [ready, setReady] = useState(false);
  const [fetchDeployedPipeline, { data: deployedPipelineData }] = useGetPipeline({ transformNotDeployed: true });
  const [fetchAttachment, { pipeline: attachmentPipeline, attachment }] = useLazyQueryPipelineIntegrationAttachment();
  // Guards against out-of-order resolution when the user switches pipelines
  // quickly: only the most recent selection's fetch is allowed to flip `ready`.
  const requestIdRef = useRef(0);

  const loadPipelineData = async ({ pipeline }) => {
    const requestId = ++requestIdRef.current;
    setReady(false);
    await Promise.all([
      fetchDeployedPipeline({ clusterId, writekey: pipeline.writekey }),
      fetchAttachment({ pipelineId: pipeline.id, integrationId }),
    ]);
    if (requestId === requestIdRef.current) {
      setReady(true);
    }
  };

  const clearPipelineData = () => {
    requestIdRef.current += 1;
    setReady(false);
  };

  return {
    loadPipelineData,
    clearPipelineData,
    ready,
    deployedPipeline: deployedPipelineData?.pipeline ?? null,
    attachment,
    clusterName: attachmentPipeline?.cluster.name ?? '',
  };
}
